import { createTheme } from '@material-ui/core/styles'

export const lightTheme = createTheme({
  spacing: (factor) => `${0.8 * factor}rem`,
  palette: {
    type: 'light',
    background: { default: '#F0F0F0', paper: '#fff' },
    primary: {
      main: '#23AA50',
      dark: '#006E2C',
    },
    secondary: {
      main: '#001D29',
      light: '#9FBBC7',
    },
    error: {
      main: '#BA1B1B',
    },
    text: {
      primary: '#003044',
      secondary: '#00658B',
    },
  },
  typography: {
    allVariants: {
      color: '#001D29',
    },
    htmlFontSize: 10,
    fontFamily: 'Source Sans Pro, sans-serif',
    body1: {
      fontSize: '1.6rem',
      fontWeight: 400,
      fontFamily: 'Source Sans Pro, sans-serif',
    },
    body2: {
      fontSize: '1.6rem',
      fontWeight: 700,
      fontFamily: 'Cabin, sans-serif',
    },
    h4: {
      fontSize: '1.6rem',
      fontWeight: 400,
      fontFamily: 'Cabin, sans-serif',
    },
    h3: {
      fontSize: '1.8rem',
      fontWeight: 500,
      fontFamily: 'Cabin, sans-serif',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 400,
      fontFamily: 'Cabin, sans-serif',
    },
    h1: {
      fontSize: '2.4rem',
      fontWeight: 600,
      fontFamily: 'Cabin, sans-serif',
    },
    caption: {
      opacity: 0.7,
      color: '#005375',
      fontSize: '1.4rem',
      fontFamily: 'Source Sans Pro, sans-serif',
    },
    subtitle1: {
      fontFamily: 'Source Sans Pro, sans-serif',
      fontWeight: 400,
      fontSize: '1.4rem',
    },
    subtitle2: {
      fontFamily: 'Source Sans Pro, sans-serif',
      fontWeight: 600,
      fontSize: '1.4rem',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        ':root': {
          '--toastify-color-info': '#003044',
          '--toastify-color-error': '#BA1B1B',
          '--toastify-font-family': 'Source Sans Pro, sans-serif',
          '--toastify-toast-min-height': 0,
          '--toastify-toast-width': '50rem',
        },
        a: {
          textDecoration: 'none',
          color: 'inherit',
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        color: 'black',
        backgroundColor: '#F0F0F0',

        border: '1px solid #001D29',
        borderRadius: 0,

        fontFamily: 'Source Sans Pro, sans-serif',
        fontSize: '1.4rem',
      },
    },
  },
})
